export default __webpack_public_path__ + "static/SRUS OC114 - Product Specifications & Technical Data-380211c564be94b01425e4b82c03fdd5.pdf";